import React from "react";
import { EndExerciseOptionModel } from "../../service/exercise";
import { htmlToPlain, replaceImgTag } from "../../utils/common";
import styles from "./index.module.scss";
import classNames from "classnames";
import { isTrue } from "../../service/service";
import { QueTypeId } from "../../service/answerStore";

interface Props {
    options: EndExerciseOptionModel[];
    title: string;
    type: QueTypeId;
}
const Index = ({ options, title, type }: Props) => {
    function getItem() {
        switch (type) {
            case QueTypeId.Judgment:
                return (
                    <ul className={classNames(styles.ul, styles.fill)}>
                        {options
                            .filter(item => isTrue(item.isRight))
                            .map((item, index) => (
                                <li
                                    key={item.id}
                                    className={classNames(
                                        isTrue(item.isRight) && styles.isRight,
                                        styles.font
                                    )}>
                                    {htmlToPlain(
                                        item.description,
                                        replaceImgTag
                                    )}
                                </li>
                            ))}
                    </ul>
                );
            case QueTypeId.Fill:
                return (
                    <ul className={classNames(styles.ul, styles.fill)}>
                        {options.map((item, index) => (
                            <li
                                key={item.id}
                                className={classNames(
                                    isTrue(item.isRight) && styles.isRight,
                                    styles.font
                                )}>
                                填空
                                {index + 1}:
                                {htmlToPlain(item.description, replaceImgTag)}
                            </li>
                        ))}
                    </ul>
                );
            default:
                return (
                    <ol className={styles.ol}>
                        {options.map(item => (
                            <li
                                key={item.id}
                                className={classNames(
                                    isTrue(item.isRight) && styles.isRight,
                                    styles.font
                                )}>
                                {htmlToPlain(item.description, replaceImgTag)}
                            </li>
                        ))}
                    </ol>
                );
        }
    }
    return (
        <div className={styles.root}>
            <h4 className={styles.title}>
                {htmlToPlain(title, replaceImgTag)}
                {getItem()}
            </h4>
        </div>
    );
};

export default Index;
